import React, { useEffect, useId, useRef, useState } from "react";
import { useTheme } from "../context/theme-context";
import { cn } from "../lib/utils";

// Mesmo tempo da transição de `.theme-switch` no theme.css.
const SWITCH_ANIMATION_MS = 300;

// Switch de tema da topbar. Rosto acordado (ligado) = tema claro; dormindo (desligado) = escuro.
// O switch anima primeiro e só depois aplica o tema: trocar o tema no mesmo instante repinta a
// página inteira e a bolinha engasgava no meio do caminho.
export default function ThemeToggle({ className = "" }) {
  const { isDark, setTheme } = useTheme();
  const id = useId();
  const [awake, setAwake] = useState(!isDark);
  const timerRef = useRef(null);

  // Acompanha o tema se ele mudar por outro caminho.
  useEffect(() => {
    setAwake(!isDark);
  }, [isDark]);

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const handleChange = (event) => {
    const nextAwake = event.target.checked;
    setAwake(nextAwake);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      setTheme(nextAwake ? "light" : "dark");
    }, SWITCH_ANIMATION_MS);
  };

  const label = awake ? "Mudar para o tema escuro" : "Mudar para o tema claro";

  return (
    <span className={cn("theme-switch", className)} title={label}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        checked={awake}
        onChange={handleChange}
        aria-label={label}
      />
      <label htmlFor={id} aria-hidden="true" />
    </span>
  );
}
